export default __webpack_public_path__ + "static/15-992932a2d56e84d080b5d5ae491577f8.webp";